export default __webpack_public_path__ + "static/media/why_img_1.5509c26c.png";